/* eslint-disable @typescript-eslint/no-explicit-any */

import { Choice } from '@generated/graphql';

const reorderChoices = (choices: Choice[], rank: string[] | undefined | null): Choice[] => {
  if (!rank || rank.length === 0) return choices;
  const orderedChoices = Array.from(choices);
  orderedChoices.sort((a, b) => {
    // use the index of the local state value in the context to resort the array, see Array sort
    const y = rank.indexOf(a.id);
    const z = rank.indexOf(b.id);
    if (y === undefined || z === undefined) return 0;
    return y - z;
  });
  return orderedChoices;
};

interface ReorderDndParams {
  current: any[];
  from: number;
  to: number;
}
const reorderDnd = ({ current, from, to }: ReorderDndParams) => {
  const cloned = [...current];
  const item = current[from];
  cloned.splice(from, 1);
  cloned.splice(to, 0, item);
  return cloned;
};

export { reorderChoices, reorderDnd };
